import React, { useContext } from 'react';

interface ListItemContextProps {
  isActionButtonHovered: boolean;
  setActionButtonHovered: (value: boolean) => void;
}

export const ListItemContext = React.createContext<ListItemContextProps | null>(
  null
);

export function useListItemContext(): ListItemContextProps {
  const context = useContext(ListItemContext);
  if (context) {
    return context;
  }
  throw new Error(
    'ListItem context can only be used within ListItem component.'
  );
}
